import "regenerator-runtime/runtime";
import _asyncToGenerator from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
import _objectSpread from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/objectSpread";
import _Promise from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/core-js/promise";
import _typeof from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/typeof";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { util } from '@tencent/vft-common';
import service from '../../services/service';
import { mapState, mapGetters, mapActions } from 'vuex';
import VipIcon from '@tencent/vft-ui/src/VipIcon/VipIcon.vue';
import PayButton from '../../components/PayButton.vue';
import { PersonalCodeStatus } from './util';
var PengDanState = {
  CanPeng: 1,
  // 能碰
  Penged: 2,
  // 已经碰过
  NoEgg: 3,
  // 没蛋了
  NoChance: 4,
  // 主人已经用完机会了
  Invalid: 5 // 过期了

  /**
   * 同时只执行一次函数，直到前一个promise返回
   * @param func
   * @returns {Function}
   */

};

function executeOneInTime(func) {
  var isRunning = false;
  return function () {
    if (!isRunning) {
      isRunning = true;
      var res = func.apply(this, arguments);

      if (_typeof(res) === 'object' && res instanceof _Promise) {
        res.finally(function () {
          isRunning = false;
        });
      } else {
        isRunning = false;
      }
    }
  };
}

export default {
  components: {
    VipIcon: VipIcon,
    PayButton: PayButton
  },
  props: ['shareCode', 'eggInfo', 'masterEggInfo', 'eggImg', 'goodList', 'masterEggImg', 'myEggImg'],
  data: function data() {
    return {
      randomGoods: '',
      PengDanState: PengDanState,
      fetchEggInfo: null
    };
  },
  created: function created() {
    var random = Math.floor(Math.random() * this.goodList.length + 1) - 1;
    this.randomGoods = this.goodList[random];
  },
  mounted: function mounted() {
    this.$reportModule({
      f_resource: '客态碰蛋浮层曝光',
      f_module: '碰蛋浮层',
      f_ext: this.masterEggInfo.master_id
    });
  },
  computed: _objectSpread({}, mapState(['isLogin']), mapGetters(['userInfo', 'payVip', 'myShareCode', 'isOfficial']), {
    pengDanState: function pengDanState() {
      if (this.masterEggInfo.personal_code_status === PersonalCodeStatus.Invalid) {
        return PengDanState.Invalid;
      } else if (this.masterEggInfo.is_today_collision) {
        return PengDanState.Penged;
      } else if (this.masterEggInfo.eggs_count === 0) {
        return PengDanState.NoChance;
      } else if (this.eggInfo.egg_count > 0) {
        return PengDanState.CanPeng;
      } else {
        return PengDanState.NoEgg;
      }
    },
    isBusinessCode: function isBusinessCode() {
      return this.masterEggInfo.eggs_type === 4;
    }
  }),
  methods: {
    toMyAward: function toMyAward() {
      this.$emit('hide');
      var myRecord = document.getElementById('mod_my_record');

      if (myRecord) {
        window.scrollTo(0, myRecord.getBoundingClientRect().top + window.scrollY - 100);
      }
    },
    cancelPeng: function cancelPeng() {
      this.$emit('hide');
    },
    goToXufei: function goToXufei() {
      this.$emit('xufei');
    },
    pengDan: executeOneInTime(
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return service.pengdan(this.shareCode);

            case 3:
              res = _context.sent;

              if (!(res.ret === 0)) {
                _context.next = 8;
                break;
              }

              this.$emit('pengSuccess', res.data);
              _context.next = 39;
              break;

            case 8:
              if (!(res.ret === -1013)) {
                _context.next = 13;
                break;
              }

              // 客人蛋不足
              this.eggInfo.egg_count = 0;
              this.$emit('refreshInfo');
              _context.next = 39;
              break;

            case 13:
              if (!(res.ret === -1014)) {
                _context.next = 18;
                break;
              }

              // 主人蛋不足
              this.masterEggInfo.eggs_count = 0;
              this.$emit('refreshInfo');
              _context.next = 39;
              break;

            case 18:
              if (!(res.ret === -1006)) {
                _context.next = 22;
                break;
              }

              this.alert('明星分享码尚未开始！');
              _context.next = 39;
              break;

            case 22:
              if (!(res.ret === -1007)) {
                _context.next = 26;
                break;
              }

              this.alert('明星分享码已结束！');
              _context.next = 39;
              break;

            case 26:
              if (!(res.ret === -1018)) {
                _context.next = 30;
                break;
              }

              this.alert('福蛋迷路了~请稍后再来！');
              _context.next = 39;
              break;

            case 30:
              if (!(res.ret === -1019)) {
                _context.next = 34;
                break;
              }

              this.alert('手速太慢没碰到，摩拳擦掌再试一次！');
              _context.next = 39;
              break;

            case 34:
              if (!(res.ret === -1021)) {
                _context.next = 38;
                break;
              }

              this.alert('系统检测到您的账号存在安全风险。');
              _context.next = 39;
              break;

            case 38:
              throw new Error("".concat(res.msg, "(").concat(res.ret, ")"));

            case 39:
              _context.next = 44;
              break;

            case 41:
              _context.prev = 41;
              _context.t0 = _context["catch"](0);
              this.alert('活动太火爆，请稍后重试');

            case 44:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 41]]);
    })))
  }
};